export enum HomePageOptionsEnum {
    GTS = "GTS",
    INA = "INA"
}